
const EXAM_TYPE_CONFIG = {
  multiplechoice: { examTypeKey: "multipleChoice", defaultSummary: "TF", kind: "auto", layout: null },
  truefalse:      { examTypeKey: "trueFalse",      defaultSummary: "TF", kind: "single", layout: "trueFalse" },
  fillblank:      { examTypeKey: "fillBlank",      defaultSummary: "TF", kind: "single", layout: "fillBlank" },
  matching:       { examTypeKey: "matching",       defaultSummary: "TF", kind: "single", layout: "matching" },
  shortanswer:    { examTypeKey: "shortAnswer",    defaultSummary: "SA", kind: "single", layout: "shortAnswer" },
  ordering:       { examTypeKey: "ordering",       defaultSummary: "ORDER", kind: "single", layout: "ordering" },
  mediaprompt:    { examTypeKey: "mediaPrompt",    defaultSummary: "TF", kind: "auto", layout: "mediaPrompt" },
  mediachoice:    { examTypeKey: "mediaChoice",    defaultSummary: "TF", kind: "auto", layout: "mediaChoice" }
}

const EXAM_TYPE_ALIASES = {
  multiplechoice: ["multiplechoice", "multiple_choice", "mc", "choice", "po", "default"],
  truefalse:      ["truefalse", "true_false", "tf", "tfo", "boolean"],
  fillblank:      ["fillblank", "fill_in_blank", "fib", "cloze"],
  matching:       ["matching", "match", "pairing"],
  shortanswer:    ["shortanswer", "short_answer", "essay", "openended", "open_ended"],
  ordering:       ["ordering", "sequence", "sequencing", "arrange", "arrangement", "sorting"],
  mediaprompt:    ["mediaprompt", "media_prompt", "mediaquestion", "hintmedia"],
  mediachoice:    ["mediachoice", "media_choice", "richchoice", "mediaselect"]
}

const normalizeExamType = raw => (raw || "").replace(/[\s_-]+/g, "").toLowerCase()

const resolveExamTypeConfig = raw => {
  const normalized = normalizeExamType(raw)
  for (const [key, aliases] of Object.entries(EXAM_TYPE_ALIASES)) {
    if (normalized === key || aliases.includes(normalized)) {
      return EXAM_TYPE_CONFIG[key]
    }
  }
  return EXAM_TYPE_CONFIG.multiplechoice
}

export function inferQuestionPresentation(q) {
  if (!q) return { kind: "single", examTypeKey: "multipleChoice", summaryKey: "TF", layout: null }

  const rawType = String(q.exam_type || q.type || "")
  const rawSummary = String((q.type_summary || q.summary || "")).toUpperCase()
  const allowMulti = q.allow_multi === true
  const hasWeight =
    rawSummary === "PO" ||
    Number.isFinite(q.weightMin) || Number.isFinite(q.weightMax) ||
    (Array.isArray(q.options) && q.options.some(o => Number.isFinite(o?.weightMin) || Number.isFinite(o?.weightMax)))

  const config = resolveExamTypeConfig(rawType)

  let summaryKey = rawSummary
  if (!summaryKey) {
    summaryKey = config.defaultSummary || (allowMulti ? "MT" : "TF")
  }

  let kind = "single"
  if (hasWeight) kind = "weighted"
  else if (summaryKey === "MT" || allowMulti) kind = "multi"
  else kind = "single"
  if (config.kind && config.kind !== "auto") {
    kind = config.kind
  }

  return { kind, examTypeKey: config.examTypeKey, summaryKey, layout: config.layout }
}
